export default "__VITE_ASSET__DyoKJrXL__"